export function ModalAppSelector() {
    if (process.env.NODE_ENV !== "test") {
        if (document.querySelector("#root")) return "#root";
    }
    return "body";
}
